<template>
  <section class="search-form" :class="{ 'prop': $props.propPage }">
    <form id="searchform" class="search_fc" @submit.prevent="checkForm" action="/searches" accept-charset="UTF-8" novalidate="novalidate" method="post">
      <div class="search-container">
        <div class="order-box">
          <div class="region-container">
            <input id="region" v-autofill="" autocomplete="" name="search[region]" placeholder="Destination" type="text" v-model="filter.region" class="search_region drive">
            <svg class="ico">
              <use xlink:href="#ico-glass"></use>
            </svg>
            <div class="absolute-container">
              <div id="autofill" class="search_drop search_drop--npad"></div>
            </div>
          </div>
          <div class="date-box box" :class="{'error': errors.date, 'opened': showPicker}">
            <input type="hidden" name="search[check_in_on]" v-model="filter.check_in_on"/>
            <input type="hidden" name="search[minimum_nights]" v-model="filter.minimum_nights"/>
            <input class="btn" @click="openLitepicker" v-picker="" readonly type="text" autocomplete="off" id="date"
                   placeholder="Check in - Check out"/>
            <div id="litepicker-container" v-show='showPicker'>
              <div class="buttons-container">
                <div class="flex-buttons">
                  <button value="3" type="button" class="flex-button" @click="setFlexPicker($event)"
                          :class="{ selected: filter.flex === '3' }">
                    &#177; 3 days
                  </button>
                  <button value="7" type="button" class="flex-button" @click="setFlexPicker($event)"
                          :class="{ selected: filter.flex === '7' }">
                    &#177; 7 days
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Select
              :options="['1+', '2+', '3+', '4+', '5+', '6+','7+', '8+', '9+', '10+', '11+','12+','13+', '14+', '15+', '16+', '17+', '18+', '19+', '20+']"
              :search="'search[sleeps]'"
              :name="'Guests'"
              :placeholder="'Guests'"
              :data.sync="filter.sleeps"
          />
          <input type="hidden" v-for="param in $props.params" :name="'search[' + param[0] + ']'" :value="param[1]"/>
          <input type="hidden" value="1" name="search[flex]"/>
          <button class="submit-search btn btn--org btn--lrg btn--wide">Search</button>
        </div>

        <div class="foot">
          <input class="form_valid form_check" id="hot_tub" v-model="filter.hot_tub" type="checkbox" name="search[hot_tub]"/>
          <label for="hot_tub" class="form_clabel">
            Show me only properties with hot tubs
          </label>
          <div class="search_pnts">
            <h3 class="search_txt">
              <svg class="search_t">
                <use xlink:href="#ico-tick"></use>
              </svg>
              Live availability
            </h3>
            <h3 class="search_txt">
              <svg class="search_t">
                <use xlink:href="#ico-tick"></use>
              </svg>
              Live prices
            </h3>
            <h3 class="search_txt">
              <svg class="search_t">
                <use xlink:href="#ico-tick"></use>
              </svg>
              Book instantly
            </h3>
          </div>
        </div>
      </div>
    </form>
  </section>
</template>

<script>

import Select from 'shared/select.vue'

export default {
  data: function () {
    return {
      url: "/searches/custom?",
      currentUrl: window.location.href,
      recentSearches: [],
      showClearRegion: false,
      loader: false,
      latLng: {},
      showPicker: false,
      initDate:null,
      initNights:null,
      initFlex:null,
      filter: {
        region: this.$props.loc || "",
        travel_origin_postcode: "",
        travel_max_time: 120,
        pets: "",
        hot_tub: "",
        check_in_on: "",
        minimum_nights: "",
        sleeps: "",
        flex: 1,
      },
      errors: {
        postcode: false,
        nights: false,
        date: false,
        time: false
      }
    }
  },
  props: {
    params: Array,
    loc: String,
    wknd: String,
    propPage: Boolean
  },
  components: {
     Select
  },
  filters: {
    endDate(date, nights) {
      let result = new Date(date);
      return st.getUserDate(result.setDate(result.getDate() + parseInt(nights)));
    },
    removeCountry(text) {
      return text.replace(/,.*$/g, '');
    }
  },
  methods: {
    hasNumber(value) {
      var filter = /\d/;
      return filter.test(value);
    },
    clearRegion() {
      this.filter.region = "";
      this.showClearRegion = false;
      this.focusEl("#region");
    },
    createUrl() {
      var app = this;
      var search = {search: app.filter};
      window.location.href = app.url + decodeURIComponent(st.serialize(search));
    },
    focusEl(el) {
      let elem = this.$el.querySelector(el);
      if (elem) {
        setTimeout(() => {
          this.$nextTick(() => elem.focus());
        }, 100);
      }
    },
    focusAndClose(el) {
      this.focusEl(el);
    },
    keyclosedrop(e) {
      let key = e.keyCode;
      if (key === 13 || key === 9) {
        this.closedrop(e);
      }
    },
    getGeocode(app) {
      st.ajax({
        url: "https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURIComponent(app.filter.travel_origin_postcode) + ".json?country=gb&access_token=pk.eyJ1Ijoic25hcHRyaXBrcmlzIiwiYSI6ImNqa2RvejJucDB5bm4zcnM1ZDlyOHVqZnQifQ.VZTOARdDaid-d4yf2Q182g",
        type: "GET",
        dataType: "json"
      }, function (response) {
        if (response.features[0]) {
          app.latLng = {lng: response.features[0].center[0], lat: response.features[0].center[1]};
          app.errors.postcode = false;
        } else {
          app.errors.postcode = true;
        }
      });
    },
    getGeoLocation(app) {
      let scope = this;
      if (navigator.geolocation) {
        app.errors.postcode = false;
        app.filter.travel_origin_postcode = "Finding...";
        navigator.geolocation.getCurrentPosition(function (position) {
          scope.getPostcode({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            data: app
          });
        }, function (error) {
          if (error.code === error.PERMISSION_DENIED) {
            app.toggleSearch();
            app.errors.postcode = true;
          }
        });
      }
    },
    getPostcode(options) {
      let app = options.data;
      st.ajax({
        url: "https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURIComponent(options.lng + "," + options.lat) + ".json?access_token=pk.eyJ1Ijoic25hcHRyaXBrcmlzIiwiYSI6ImNqa2RvejJucDB5bm4zcnM1ZDlyOHVqZnQifQ.VZTOARdDaid-d4yf2Q182g",
        type: "GET",
        dataType: "json"
      }, function (response) {
        app.filter.travel_origin_postcode = response.features[0].context[0].text;
        app.latLng = {lng: options.lng, lat: options.lat};
      });
    },
    geoCode() {
      this.getGeocode(this);
    },
    findMyLocation() {
      this.toggleSearch();
      this.getGeoLocation(this);
    },
    toggleSearch() {
      let app = this;
      app.filter.travel_max_time = 120;
      app.filter.travel_origin_postcode = "";
      app.errors.postcode = false;
      this.focusEl("#region");
    },
    goToSearch(id) {
      window.location.href = id ? "/searches/" + id : "/top-deals";
    },
    //history 
    getHistory(item, limit) {
      let history = localStorage.getItem(item),
          newData = [];
      if (st.checkLocal() && history !== null && history.length > 0) {
        newData = JSON.parse(history).slice(0, limit);
        return newData.reverse();
      } else {
        return [];
      }
    },
    cleanSearchHistory() {
      let app = this;
      let today = new Date().getTime(),
          allRecords = app.getHistory("search_history", 10),
          records = [];
      for (let i = 0; i < allRecords.length; i++) {
        let record = allRecords[i];
        if ((record.isochrone_uuid !== "" || record.region !== "") && new Date(record.check_in_on).getTime() > today) {
          if (records.length < 3) {
            records.push(record);
          }
        }
      }
      if (records.length === 1 || records.length === 2) {
        app.pushTopDealsCard(records);
      }
      return records;
    },
    pushTopDealsCard(records) {
      let app = this;
      records.push({
        region: "Latest UK deals",
        check_in_on: app.$props.wknd,
        nights: 3,
        minimum_nights: 3,
        isochrone_uuid: ""
      });
    },
    //validation & submission
    checkForm() {
      let scope = this;
      let form = scope.$el.children[0];
      scope.clearAll();
      scope.validateForm(scope, form);
    },
    clearAll() {
      this.errors.nights = false;
      this.errors.date = false;
      this.errors.time = false;
    },
    isRefOnly(value) {
      return this.hasNumber(value);
    },
    validateForm(scope, form) {
      let app = this;
      if (scope.filter.minimum_nights === 0 || scope.filter.minimum_nights === "") {
        scope.errors.nights = true;
      }
      if (scope.filter.check_in_on === "") {
        scope.errors.date = true;
      }
      if (app.isRefOnly(scope.filter.region) || !(scope.errors.date || scope.errors.nights || scope.errors.postcode)) {
        form.submit();
      }
    },
    getResults(app, callback) {
      app.loader = true;
      new en.iso({
        time: app.time,
        position: app.latLng,
        callback: function (response) {
          callback(response, app);
        }
      });
    },
    sortSuggestionLists(response, term) {
      let matchedArray = [];
      let unmatchedArray = [];
      let newArray = [];
      let inputValue = term.toUpperCase();

      response.forEach(value => {
          let locationName = value.split(",")[0].toUpperCase();

          if (locationName.indexOf(inputValue) === 0) {
              matchedArray.push(value);
          } else {
              unmatchedArray.push(value);
          }
      });

      newArray = [...matchedArray, ...unmatchedArray];
      return newArray
    },
    setFlexPicker: function(ev) {
      const value = ev.target.value;

      if (value === this.filter.flex) {
        this.filter.flex = 1;
      } else {
        this.filter.flex = value;
      }
    },
    openLitepicker: function() {
        let app = this;
        app.initDate = app.filter.check_in_on;
        app.initNights = app.filter.minimum_nights;
        app.initFlex = app.filter.flex
        app.showPicker= true;
    },
    closeLitepicker: function() {
        let app = this;
        app.showPicker = false;
    },
  },
  directives: {
    'autofill': {
      inserted: (el, binding, vnode) => {
        let af = document.querySelector("#autofill");
        let app = vnode.context,
            url = window.location.href;
        el.autofill = new autoComplete({
          selector: el,
          minChars: 1,
          cache: false,
          source: function (term, suggest) {
            if (term.length > 2) {
              st.ajax({
                url: "/searches/autocomplete?query=" + encodeURIComponent(term.toLowerCase()),
                type: "GET",
                csrf: st.getCSRFToken(),
                dataType: "json"
              }, function (response) {
                suggest(response);
              });
            }
          },
          renderItem: function (item, search) {
            search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
            if (item.includes(",")) {
              return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[0] + '<br /><span class="sub-region">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[1] + '</span></div>';
            } else {
              return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
            }
          },
          onSelect: function (e, term, item) {
            e.preventDefault();
            app.filter.region = term;
          }
        });
        if (af) {
          af.appendChild(document.querySelector(".autocomplete-suggestions"));
        }
        el.autocomplete = url.indexOf("snaptrip") > -1 && url.indexOf("properties") === -1 ? "new-password" : "off";
      },
      unbind: (el) => {
        el.autofill.destroy();
      }
    },
    'picker': {
      inserted: function(el, binding, vnode) {
        let app = vnode.context;

        el.picker = new Litepicker({
          element: document.getElementById('date'),
          parentEl: document.getElementById('litepicker-container'),
          singleMode: false,
          autoApply: false,
          resetButton:true,
          allowRepick: true,
          minDate: new Date() -1,
          numberOfColumns: 2,
          numberOfMonths: 2,
          switchingMonths: 1,
          minDays: 2,
          maxDays: 29,
          format: "D MMM YYYY",
          tooltipText: {
            one: 'night',
            other: 'nights'
          },
          inlineMode:true,
          buttonText: {
            cancel:'Close'
          },
          tooltipNumber: (totalDays) => {
            return totalDays - 1;
          },
          setup: (picker) => {
            picker.on('button:cancel', () => {
                if (app.initDate) {
                    let checkOut = new Date(app.initDate)
                    let checkOutDate = new Date(checkOut.getTime())
                    checkOutDate.setDate(checkOutDate.getDate() + parseInt(app.initNights))
                    picker.setDateRange(checkOut, checkOutDate)
                } else {
                    picker.clearSelection()
                }
               
                app.filter.flex = app.initFlex
                app.closeLitepicker();
            });

            picker.on('clear:selection', () => {
                 app.filter.flex = 1
            });

            picker.on('preselect', (date1, date2) => {
                if (date2) {
                    picker.setDateRange(date1, date2)
                }
            });

            picker.on('button:apply', (date1, date2) => {
                if (date2) {
                    const timeDiff = Math.abs(date2.dateInstance.getTime() - date1.dateInstance.getTime());
                    app.filter.check_in_on = date1.dateInstance.toString().split('00:00:00')[0];
                    app.filter.minimum_nights = Math.ceil(timeDiff / (1000 * 3600 * 24));
                } else {
                    app.filter.check_in_on = "";
                    app.filter.minimum_nights = "";
                }

                app.closeLitepicker();
            });
          }
        });
      },
      unbind: function unbind(el) {
        el.picker.destroy();
      }
    }
  },
  mounted: function () {
    let app = this;
    app.recentSearches = app.cleanSearchHistory();
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.search-form {
  padding: 1.25rem;

  &.prop {
    .search-container {
      .order-box {
        order: initial;
      }

      .form_clabel {
        color: #000;
        text-shadow: none;
        box-sizing: border-box;
        cursor: pointer;
      }

      .btn--lrg {
        padding: 0 2rem;
      }
    }
  }

  h1 {
    padding: 0 1.25rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 3.5rem;
    font-size: 1.5rem;
    text-shadow: 0 0.125rem 0.125rem #221F20;
    position: relative;
    z-index: 2;
    font-weight: 400;
    color: #FFF;
    text-align: center;

    span {
      font-weight: 700;
      color: #fff;
    }
  }

  .ico {
    right: 1.25rem;
    position: absolute;
    top: 1rem;
    stroke: #FC5C30;
    stroke-width: 2rem;
    cursor: pointer;
    width: 1.25rem;
    height: 1.25rem;
    z-index: 2;

    &.search_icon_close {
      right: 3.2rem;
      stroke: none;
    }
  }

  .search_icon {
    width: 1.4rem;
    height: 1.4rem;
    right: 1.25rem;
    border-radius: 100%;
    border: none;
    background: #FC5C30;
    color: #FFF;
    text-align: center;
    line-height: 1.4rem;
    position: absolute;
    top: 1rem;
    z-index: 2;
    cursor: pointer;
  }

  .search-container {
    max-width: 40rem;
    margin: 0 auto;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;

    h1 {
      order: 1;
    }

    .ctr {
      order: 2;
    }

    .order-box {
      order: 3;
      padding: 1.25rem 0 0 0;
    }
  }

  .search_loader {
    display: none;
    border-radius: 0.19rem;
    width: 100%;
    left: 0;
    bottom: 0;
    height: 24rem;
    position: absolute;
    background: #FFF;
    z-index: 100;
    padding: 1.25rem;
    box-sizing: border-box;

    &.visible {
      display: block;

      .search_loadcap span {
        animation: blink 1.4s infinite;
        animation-fill-mode: both;
        font-size: 1.5rem;

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }

    .center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .ico {
        width: 4.375rem;
        height: 4.375rem;
        cursor: pointer;
        stroke: #000;
        stroke-width: 0;
        position: relative;
        right: 0;
      }

      .search_loadcap {
        margin: 1rem 0 0 0;
      }
    }
  }

  .search-row {
    height: 3.125rem;
    position: relative;
    width: calc(50% - .625rem);
    float: left;
    margin-bottom: 1.25rem;
    box-sizing: border-box;
  }

  .search_region {
    box-sizing: border-box;
    position: relative;
    z-index: 2;
    line-height: 3.125rem;
    font-size: 0.875rem;
    width: 100%;
    padding: 0 2rem 0 1rem;
    height: 3.125rem;
    line-height: 3.125rem;
    font-size: 0.875rem;
    outline: 0;
    position: relative;
    cursor: text;
    float: left;
    border-radius: .188rem;
    margin-bottom: 1.25rem;
    box-sizing: border-box;

    &::-ms-clear {
      display: none;
    }
  }

  .btn {
    width: calc(50% - 0.625rem);
    margin: 0 0 0 .625rem;
  }

  svg.search_t {
    height: 1rem;
    width: 1rem;
  }

  .form_clabel {
    float: left;
    width: 100%;
  }

  .search_drop {
    background-color: #FFF;
    box-sizing: border-box;
    max-width: 100%;
    border-radius: .188rem;
    top: 0;
    left: 0;
    z-index: 7;
    max-height: 1000px;
    overflow: initial;

    &--h {
      position: relative;
      height: 100%;
      line-height: 3.125rem;
      font-size: 0.875rem;
      width: 100%;
      padding: 0 2rem 0 1rem;
      cursor: pointer;
    }

    svg {
      margin-top: -0.813rem;
      right: 1.25rem;
      position: absolute;
      top: 50%;
      stroke-width: initial;
      fill: #FC5C30;
      cursor: pointer;
      width: 1.563rem;
      height: 1.563rem;
    }
  }

  .region-container {
    position: relative;
    width: 100%;
  }

  .absolute-container {
    position: absolute;
    box-sizing: border-box;
    top: 0;
    z-index: 1;
    width: 100%;
    padding: 3rem 0 0 0;
    border: 0.063rem solid #9B9B9B;
    border-radius: .188rem;

    &.drive {
      z-index: 2;
      border: 0.063rem solid #9B9B9B;
      padding: 0;
      line-height: 3.125rem;
      font-size: 0.875rem;
      outline: 0;
      background: $col_white;
      float: left;

      &.error {
        border: 0.063rem solid $col_red;
        color: $col_red;

        input,
        input::placeholder {
          color: $col_red;
        }
      }

      &.shadow {
        box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.3);
      }

      .search_drop {
        height: 100%;
        height: 3.125rem;
        padding: 0 2rem 0 1rem;
      }

      select {
        height: 100%;
        font-size: 0.875rem;
        outline: 0;
        width: auto;
        max-width: 5.625rem;
        font-weight: 700;
        background: transparent;
      }

      span {
        margin: 0 0.5rem;
        height: 100%;
        font-size: 0.875rem;
        outline: 0;
        width: auto;
      }

      input {
        height: 100%;
        line-height: 3.125rem;
        font-size: 0.875rem;
        outline: 0;
        width: 80%;
        max-width: 5.625rem;
        font-weight: 700;

        &::placeholder {
          font-weight: 400;
        }
      }
    }
  }

  .history {
    box-sizing: border-box;
    list-style: none;
    padding: 0;
    line-height: 3.125rem;
    font-size: 0.875rem;
    width: 100%;
    cursor: pointer;
    background: $col_white;

    &:after {
      content: '';
      position: absolute;
      width: 90%;
      left: 50%;
      transform: translateX(-50%);
      background: #B4B4B4;
      height: 1px;
      display: block;
      z-index: 8;
    }

    li {
      font-weight: 700;
      text-transform: capitalize;
      width: 100%;
      box-sizing: border-box;
      padding: 1rem;
      font-size: 0.8rem;
      cursor: pointer;

      &:hover {
        p, span {
          color: $col_orange;
        }
      }

      p {
        display: inline-block;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-wrap: normal;
        width: 40%;
      }

      span {
        float: right;
        font-weight: 400;
        width: 60%;
        text-transform: uppercase;
        text-align: right;
      }
    }
  }

  .search_pnts {
    padding: 1.25rem 0 0;
    width: 100%;
    position: relative;
    flex-direction: row;
    flex: 1 1 auto;
    display: none;
  }

  .search_txt {
    text-align: center;
    font-weight: 400;
    width: calc(100% / 3);
    font-size: .875rem;

    .search_t {
      width: .875rem;
      top: .125rem;
      height: .875rem;
      position: relative;
      fill: $col_white;
    }
  }

  .foot {
    padding: 1.25rem 0;

    & * {
      color: $col_white;
      text-shadow: 0 0.125rem 0.125rem #221F20;
    }
  }
}

@keyframes blink {
  0% {
    opacity: .2;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .2;
  }
}

@media #{$xs-phone} {
  .search-form .history li span {
    font-size: .7rem;
  }
}

@media #{$phablet} {
  .search-form .search-container .order-box {
    padding: 1.25rem;
  }
}

@media #{$desktop} {
  .search-form {
    height: 26.25rem;
    width: 27.5rem;
    position: absolute;
    top: 7.5rem;
    margin: 0 0 0 1.25rem;
    padding: 0;

    &.prop {
      position: inherit;
      width: inherit;
      height: inherit;
      margin: inherit;
      margin-top: 1.25rem;
      padding: inherit;

      .foot {
        display: flex;
        padding: 0;

        .search_pnts {
          padding: 0;
        }

        .form_clabel {
          width: 90%;
        }
      }

      input {
        padding: 0 3.5rem 0 1rem;
      }

      .search-container {
        max-width: 80%;
        margin-bottom: 2.5rem;
        background-image: none;

        .order-box {
          display: flex;

          .box, .btn {
            margin: 0;
          }

          .box, .region-container {
            margin-right: 1.25rem;
          }

        }
      }
    }

    .search_region {
      border: 0.063rem solid #9B9B9B;
    }

    h1 {
      font-weight: 400;
      margin-bottom: 1.25rem;
      font-size: 1.5rem;
      color: #000;
      text-align: left;
      padding: 0;
      margin-top: 0;
      text-shadow: none;

      span {
        color: #000;
      }
    }

    .search_loader {
      height: 27rem;
      top: 0;
    }

    .search-container {
      padding: 1.25rem;
      background-color: #FFF;
      position: relative;
      box-sizing: border-box;
      border-radius: .19rem;
      box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.3);
      display: block;

      .order-box {
        padding: 0;
      }
    }

    .foot {
      & * {
        color: $col_black;
        text-shadow: none;
      }

      .search_t {
        fill: black;
      }
    }

    .search_pnts {
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
    }
  }
}
</style>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.prop .box input,
.prop .box .select {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5);
}

.prop .box input, .prop .box .select {
  box-shadow: none;
}

.prop .box {
  display: inline-block;
  width: calc(50% - 0.625rem);
  float: left;
  margin: 0 .625rem 0 0;

  &.error input.btn {
    border: 0.063rem solid $col_red;
  }

  .select {
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg enable-background='new 0 0 500 500' version='1.1' viewBox='0 0 500 500' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate%28-186 -303%29'%3E%3Cg transform='translate%2820 281%29'%3E%3Cg transform='translate%28160 15%29'%3E%3Cpath d='m29.729 155.09c0-4.702 1.671-9.28 5.015-12.817 6.735-7.074 17.638-7.074 24.324 0l193.9 204.46 193.97-204.46c6.688-7.074 17.639-7.074 24.324 0 6.688 7.075 6.688 18.559 0 25.609l-197.48 208.07c-11.51 12.114-30.117 12.114-41.502 0l-197.53-208.07c-3.344-3.513-5.014-8.19-5.014-12.792z' fill='%234B4A4B'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E ");
    background-size: 0.813rem;
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    box-sizing: border-box;

    &:after {
      display: none;
    }

    select {
      padding: 0.5rem 1rem;
      line-height: 1.2rem;
      font-size: .875rem;
      width: 130%;
      background: transparent;
      font-weight: 400;
      text-transform: capitalize;
    }
  }

  &:nth-of-type(3) {
    //margin: 0 0 0 .625rem;
    margin: 0;
  }

  .btn {
    width: 100%;
    padding: 1rem 0;

  }

  .select {
    height: 3.125rem;
    position: relative;
    width: calc(50% - .625rem);
    float: left;
    margin-bottom: 1.25rem;
    box-sizing: border-box;
    border: none;
    line-height: 3.125rem;
    width: 100%;
    border-radius: .188rem;
    background-color: #FFF;
  }

  input.btn {
    background: $col_white;
    line-height: 3.125rem;
    font-size: .875rem;
    font-weight: 400;
    text-transform: capitalize;
    text-align: left;
    padding: 0 0 0 1rem;
    border: none;
    border-radius: .188rem;

    &#date {
      padding: 0 1rem;
    }

    &::placeholder {
      color: #7F8C8D;
    }
  }
}


.autocomplete-suggestion {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
  font-size: 0.875rem;
  line-height: 1.125rem;
  padding: .75rem 0 .75rem 1rem;
  cursor: pointer;

  .sub-region {
    font-size: .75rem;
  }

  &:hover, &.selected {
    color: $col_orange;

    .sub-region {
      color: $col_orange;
    }
  }
}

@media #{$desktop} {
  .prop .region-container input,
  .prop .box input,
  .prop .box .select {
    box-shadow: none;
  }
  .prop .box input.btn,
  .prop .box .select {
    border: 0.063rem solid #9B9B9B;
  }
  .prop .box.error input.btn,
  .prop .box.error .select {
    border: 0.063rem solid $col_red;
  }
  .search-form.prop {
    input {
      padding: 0 1rem;
    }
  }
}

// litepicker

.date-box {
  #date {
    margin: 0;
  }

  @media #{$desktop} {
    position: relative;
    max-height: max-content;
  }
}

#litepicker-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: $col_white;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  z-index: 1;

  @media #{$desktop} {
    height: auto;
    top: unset;
    left: unset;
    border-radius: 0.188rem;
    width: 574.78px;
  }

  .litepicker {
    position: relative !important;
    top: unset !important;
    left: unset !important;
    order: 1;
    height: auto;
    margin-top: 1.5rem;
    
    @media #{$desktop} {
      margin-top: 0;
    }

    .day-item {
      margin: 1px 0;

      &.is-today {
        color: $col_primary !important;
      }

      &.is-start-date {
        color: $col_white !important;
      }

      &.is-start-date, &.is-end-date {
        background-color: $col_primary !important;

        &:hover {
          color: $col_white !important;
        }
      }

      &.is-in-range {
        background: #fd8462 !important;
        color: $col_white !important;
      }

      &:hover {
        border-color: $col_primary !important;
        color: $col_primary !important;
        box-shadow: inset 0 0 0 1px $col_primary !important;
      }
    }
  }

  .buttons-container {
    order: 2;
    margin: 0rem auto;
    max-width: 30rem;
    width: 100%;
    box-sizing: border-box;
    padding: 0 1rem;
    position: fixed;
    bottom: 1.25rem;
    left: 0;

    @media #{$desktop} {
      max-width: unset;
      margin: 0.5rem 0 1rem 0;
      padding: 0 5px;
      position: relative;
      bottom: unset;
      left: unset;
    }

    .flex-buttons {
      display: flex;
      flex-direction: row;
      margin-bottom: 1rem;

      @media #{$desktop} {
        padding: 0 5px;
        margin-bottom: 0;
      }

      .flex-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        text-align: center;
        border: 1px solid #dddddd;
        background-color: $col_white;
        outline: none;
        color: #222222;
        position: relative;
        transition-duration: 0.15s;
        transition-timing-function: ease-in-out;
        padding: 8px 16px;
        min-height: 2rem;
        border-radius: 1rem;
        font-size: 0.8rem;
        line-height: 1.25rem;
        margin-right: .5rem;

        &.selected {
          border-color: $col_primary;
          -webkit-box-shadow:inset 0 0 0 1px $col_primary;
          -moz-box-shadow:inset 0 0 0 1px $col_primary;
          box-shadow:inset 0 0 0 1px $col_primary;

          &:hover {
            border-color: $col_primary;
          }
        }

        &:hover {
          border-color: $col_black;
        }

        @media #{$desktop} {
          padding: 4px 12px;
        }
      }
    }

    .close-button {
      background: $col_primary;
      padding: 0 2.5rem;
      font-size: .875rem;
      border-radius: 0.2rem;
      box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.15);
      height: 3.125rem;
      color: $col_white;
      font-weight: 700;
      width: calc(50vw - 1.5rem);
      cursor: pointer;

      &:hover, &:active {
        background: #fd8462;
      }

      @media #{$desktop} {
        display: none;
      }
    }
  }

  .reset-button {
    background: $col_white;
    padding: 0 2.5rem;
    font-size: .875rem;
    border-radius: 0.2rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.15);
    border: 1px solid $col_primary;
    height: 3.125rem;
    color: $col_primary !important;
    font-weight: 700;
    width: calc(50vw - 1.5rem);
    cursor: pointer;
    position: fixed;
    bottom: 1.25rem;
    right: 1rem;

    svg {
      display: none;
    }

    &::before {
      content: "Clear";
    }

    &:hover, &:active {
      background: $col_white;
    }

    @media #{$desktop} {
      position: absolute;
      bottom: -2.75rem;
      width: 140px;
    }
  }

  .container__months {
    box-shadow: none;
  }
}

</style>
